import React from 'react';
import { observer } from 'mobx-react';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';
import { Box, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import couponImg from './assets/coupon.svg';
import { formatWelcomeGiftValue } from '../../cashback/utils';

const WelcomeDiscountCoupon: React.FC<{
  sx?: SxProps<Theme>
}> = observer(({ sx }) => (!AppWelcomeGiftStore.welcomeGift ? null : (
  <Box
    sx={{
      background: `url(${couponImg})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      p: 2,
      fontSize: '1.8rem',
      fontWeight: 600,
      textAlign: 'center',
      color: '#28292c',
      ...sx,
    }}
  >
    {formatWelcomeGiftValue(AppWelcomeGiftStore.welcomeGift)}
  </Box>
)));

export default WelcomeDiscountCoupon;
